import { useState } from 'react';

interface MutationLike<TVariables> {
  mutate: (
    variables: TVariables,
    options: { onSuccess: () => void; onError: (error: unknown) => void },
  ) => void;
  isPending: boolean;
}

export function useConfirmedAction<TVariables>(mutation: MutationLike<TVariables>, onDone?: () => void) {
  const [isOpen, setIsOpen] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const close = () => {
    setIsOpen(false);
    setError(null);
  };

  const confirm = (variables: TVariables) => {
    setError(null);
    mutation.mutate(variables, {
      onSuccess: () => {
        close();
        onDone?.();
      },
      onError: (failure) => setError((failure as Error).message),
    });
  };

  return {
    isOpen,
    open: () => setIsOpen(true),
    close,
    confirm,
    error,
    isPending: mutation.isPending,
  };
}
